export default "__VITE_ASSET__BX9ZgF_q__"